/**
 * How every run-analysis dialog is opened — Surface Difference, Deviation,
 * Clearance and Layer Stack.
 *
 * These four are the long ones: surfaces, resolution, colour ramp, the
 * station corridor, crossfall bands, thickness expectations, report options.
 * They fill most of the viewport, which is exactly what makes an outside
 * click so easy to hit by accident — and losing one throws the whole
 * configuration away with no undo and no warning. So they opt out of
 * dismiss-on-outside-click. Escape and the ✕ still close them.
 */
import type { DialogOptions } from '@/providers/DialogProvider';

export const ANALYSIS_DIALOG_OPTIONS: DialogOptions = { dismissOnOutsideClick: false };

/**
 * The height cap for a dialog whose own root does NOT already set one.
 *
 * **Do not add this to a dialog that caps itself.** `DialogContent`'s default
 * is `grid … gap-4 p-6`; this class turns it into a `max-h-[80vh]`,
 * `overflow-hidden` flex column. A form that is itself `max-h-[80vh] flex
 * flex-col` then becomes a column flex ITEM whose automatic `min-height: auto`
 * refuses to shrink below its content — so it stays taller than the capped
 * parent and `overflow-hidden` clips its bottom. The bottom is the
 * `DialogFooter`, i.e. the Run button, which simply vanishes with no scrollbar
 * to hint that anything is missing.
 *
 * That is exactly what happened to Deviation and Surface Difference when this
 * was applied to all four dialogs at once: both cap themselves in their own
 * `<form>` and had always been opened with no className. Only Clearance and
 * Layer Stack — whose roots do not cap themselves — take it.
 */
export const ANALYSIS_DIALOG_CLASS = 'flex max-h-[80vh] min-w-0 flex-col overflow-hidden';
